import { inject, Injectable } from '@angular/core';
import { environment } from '@web-builder-env/environment';

import { type SelectedFileExtended } from '@common/types/file.type';
import { setChatAt } from '@common/helpers/string';

import { TransferStateService } from '@web-builder/core/services/transfer-state.service';

@Injectable({
    providedIn: 'root',
})
export class ImageService {
    private readonly SRCSET: { size: number; media: string }[] = [
        {
            size: 720,
            media: '(max-width: 720px)',
        },
        {
            size: 1080,
            media: '(max-width: 1080px)',
        },
        {
            size: 1920,
            media: '(min-width: 1081px)',
        },
    ];

    private readonly transferStateService: TransferStateService = inject(TransferStateService);

    public formatImageSrc(src: string): string {
        return `${environment.fileManagerCdnUrl}${src}`;
    }

    public convertImgSrcToResizeSrc(sourceImageUrl: string): string {
        const splitSourceImageUrl = sourceImageUrl.split('/');

        if (sourceImageUrl.includes('sp-fm') || sourceImageUrl.includes('sp-fm-pre')) {
            splitSourceImageUrl.splice(5, 0, 'resize_landing');
        } else {
            splitSourceImageUrl.splice(4, 0, 'resize_landing');
        }
        const extensionDotIndex = splitSourceImageUrl[splitSourceImageUrl.length - 1].lastIndexOf('.');
        splitSourceImageUrl[splitSourceImageUrl.length - 1] = setChatAt(
            splitSourceImageUrl[splitSourceImageUrl.length - 1],
            extensionDotIndex,
            '_',
        );

        return encodeURI(splitSourceImageUrl.join('/'));
    }

    public getImageResizeSrcset(imageFile: SelectedFileExtended, imageSrc: string): { size: number; media: string; url: string }[] | null {
        const src = this.convertImgSrcToResizeSrc(imageSrc);

        return this.SRCSET.map((item) => {
            if (item.size >= imageFile.imageWidth || imageFile.extension.includes('svg')) {
                if (imageFile?.hasSourceResize) {
                    return { ...item, url: `${src}/source.webp` };
                }

                return { ...item, url: imageSrc };
            }

            return { ...item, url: `${src}/${item.size}.webp` };
        });
    }
}
